import React, { useEffect } from "react";
import { useGetIdentity } from "@refinedev/core";
import { ENV } from "@/config/env";
import "./DifyChatWidget.css";

declare global {
  interface Window {
    difyChatbotConfig?: {
      token: string;
      baseUrl?: string;
      isDev?: boolean;
      systemVariables?: { user_id?: string };
      inputs?: Record<string, string>;
      draggable?: boolean;
      containerProps?: Record<string, unknown>;
    };
  }
}

export const DifyChatWidget: React.FC = () => {
  const { data: identity } = useGetIdentity<{ id: string; name: string }>();

  useEffect(() => {
    if (!ENV.DIFY_ENABLED || !ENV.DIFY_TOKEN) return;

    // Configure before loading script
    window.difyChatbotConfig = {
      token: ENV.DIFY_TOKEN,
      baseUrl: ENV.DIFY_BASE_URL,
      systemVariables: {
        user_id: identity?.id || "anonymous",
      },
      inputs: {
        user_name: identity?.name || "",
      },
      draggable: true,
    };

    // Avoid duplicate script injection
    if (document.getElementById("dify-chatbot-script")) return;

    // Load embed script dynamically
    const script = document.createElement("script");
    script.src = `${ENV.DIFY_BASE_URL}/embed.min.js`;
    script.async = true;
    script.defer = true;
    script.id = "dify-chatbot-script";
    document.body.appendChild(script);

    return () => {
      const el = document.getElementById("dify-chatbot-script");
      if (el) el.remove();
      const bubble = document.getElementById("dify-chatbot-bubble-button");
      if (bubble) bubble.remove();
      const chatWindow = document.getElementById(
        "dify-chatbot-bubble-window"
      );
      if (chatWindow) chatWindow.remove();
    };
  }, [identity?.id, identity?.name]);

  return null;
};
